import * as React from 'react';
import { ArrowLeft } from '@/components/icons';
import { Button, type ButtonProps } from '@/components/ui/button';

export const BackButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            children = 'Voltar',
            className,
            variant = 'ghostBrand',
            size = 'icon',
            'aria-label': ariaLabel,
            title,
            ...props
        },
        ref,
    ) => {
        const label = ariaLabel || (typeof children === 'string' ? children : 'Voltar');

        return (
            <Button
                ref={ref}
                type="button"
                variant={variant}
                size={size}
                aria-label={label}
                title={title || label}
                className={className}
                {...props}
            >
                <ArrowLeft className="size-4" />
            </Button>
        );
    },
);

BackButton.displayName = 'BackButton';
